import { getConfig } from "@/config/config";
import { getAppropriateApiUrl, getSgwtConnect, useFake, getFakeUser } from "@/sgwtConnect";
import { type BaseQueryFn, type FetchBaseQueryError, type FetchArgs, type BaseQueryApi, fetchBaseQuery } from "@reduxjs/toolkit/query";

type UnwrapPromise<T> = T extends PromiseLike<infer V> ? V : T;
type BaseQueryMeta<BaseQuery extends BaseQueryFn> = UnwrapPromise<ReturnType<BaseQuery>>['meta'];
type QueryReturnValue<T = unknown, E = unknown, M = unknown> = {
  error: E;
  data?: undefined;
  meta?: M;
} | {
  error?: undefined;
  data: T;
  meta?: M;
};

export type WebAPIQueryResult<T> = QueryReturnValue<T, FetchBaseQueryError, BaseQueryMeta<BaseQueryFn>>;

export const webApiResponseBaseQuery = async <T>(
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: object,
): Promise<WebAPIQueryResult<T>> => {
  const apiUrl = getAppropriateApiUrl(getConfig().api_url, getConfig().api_url_for_lan);

  return (
    fetchBaseQuery({
      baseUrl: apiUrl,
      prepareHeaders: (headers) => {
        headers.set('Authorization', getSgwtConnect().getAuthorizationHeader() ?? '');
        if (useFake) {
          headers.set('X-Fake-Authentication', getFakeUser());
        }
      },
    }) as BaseQueryFn<string | FetchArgs, T, FetchBaseQueryError, BaseQueryMeta<BaseQueryFn>>
  )(args, api, extraOptions);
};
